import { Loader2 } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface StartChatConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  freelancerName?: string | null
  onConfirm: () => void
  isStartingChat?: boolean
}

export function StartChatConfirmationDialog({
  open,
  onOpenChange,
  freelancerName,
  onConfirm,
  isStartingChat = false,
}: StartChatConfirmationDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-[24px]">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-2xl font-normal text-slate-900">
            Start a conversation?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-slate-500">
            Ready to start chatting with {freelancerName || 'this Genius'}?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="rounded-[48px] border-2 border-slate-200 disabled:opacity-50 disabled:cursor-not-allowed">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isStartingChat}
            className="rounded-[48px] text-white font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              background: 'linear-gradient(106.66deg, rgba(70, 105, 237, 1) 0%, rgba(54, 84, 233, 1) 100%)',
            }}
          >
            {isStartingChat ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Starting...
              </>
            ) : (
              'Start Chat'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
